import Axios from 'axios';

import { APPLICATION_CONSTANTS } from 'AppConstants';
import { getDvid } from 'UtilityComponents/Util';

export const getUserServiceAxiosConfig = (customHeaders) => {
	const dvid = getDvid();
	let userConfig = {
		baseURL: '//mapi.makemytrip.com',
		timeout: 30000,
		headers: {
			'Content-Type': 'application/json',
			'Authorization': APPLICATION_CONSTANTS.HCS_USER_SERVICE_AUTHORIZATION,
			'Accept': 'application/json',
			'User-Identifier': `"{\"type\": \"mmt-auth\" ,\"profileType\": 1,\"deviceId\" : \"${dvid}\", \"os\":\"os\", \"osVersion\":\"osVersion\", \"appVersion\":\"appVersion\", \"imie\":\"imie\", \"ipAddress\":\"ipAddress\", \"timeZone\":\"timeZone\",\"value\": \"\"}"`
		}
	};

	if (customHeaders) {
		userConfig['headers'] = { ...userConfig['headers'], ...customHeaders };
	}
	return Axios.create(userConfig);
};
